/**
 * Widget Components - HOC Wrapped
 * All widget components are wrapped with withWidgetWrapper HOC for unified top bar, drag handle, and menu
 */

import React from "react";
import { WidgetId } from "../types";
import {
  RetirementReadinessWidget,
  AUMByProductWidget,
  ContributionRateWidget,
  SocialSecurityWidget,
  RetirementIncomeSourcesWidget,
  FEGLIRiskWidget,
  AgeDistributionWidget,
  RolloverOpportunityWidget,
  EmployerMatchWidget,
  LocationInsightsWidget,
  PlanTypeSpreadWidget,
  LongevityStressWidget,
} from "../widgets";
import { withWidgetWrapper } from "../components/withWidgetWrapper";

// All widget components are wrapped with the HOC
export const WIDGET_COMPONENTS: Record<WidgetId, React.ComponentType<any>> = {
  "retirement-readiness": withWidgetWrapper(RetirementReadinessWidget),
  "aum-by-product": withWidgetWrapper(AUMByProductWidget),
  "contribution-rate": withWidgetWrapper(ContributionRateWidget),
  "social-security": withWidgetWrapper(SocialSecurityWidget),
  "retirement-income-sources": withWidgetWrapper(RetirementIncomeSourcesWidget),
  "fegli-risk": withWidgetWrapper(FEGLIRiskWidget),
  "age-distribution": withWidgetWrapper(AgeDistributionWidget),
  "rollover-opportunity": withWidgetWrapper(RolloverOpportunityWidget),
  "employer-match": withWidgetWrapper(EmployerMatchWidget),
  "location-insights": withWidgetWrapper(LocationInsightsWidget),
  "plan-type-spread": withWidgetWrapper(PlanTypeSpreadWidget),
  "longevity-stress": withWidgetWrapper(LongevityStressWidget),
};
